import { connection } from '@/api/connection'

export default {
  getContractRelations: ({ id }) => connection.get(`bo/v2/contracts/${id}/relations`),
  postContractRelation: ({ id, relationData }) => connection.post(`bo/v2/contracts/${id}/relations`, relationData),
  putContractRelation: ({ id, relationId, relationData }) => connection.put(`bo/v2/contracts/${id}/relations/${relationId}`, relationData),
  deleteContractRelation: ({ id, relationId }) => connection.delete(`bo/v2/contracts/${id}/relations/${relationId}`)
}
